<template>
  <div class="container">
    <div
      id="mask"
      v-if="popupState==='SHOW'||popupState==='ERROR'"
      @click="popupState='';$refs.tan.focus()"
    ></div>
    <transition name="err">
      <div class="popup" @click="popupState=''" v-if="popupState==='SHOW'">
        <button @click="popupState='';$refs.tan.focus()">X</button>
        <h2>{{ $t("tan.help.codes") }}</h2>
        <div class="row">
          <div class="col-4">
            <img :src="imageUrl()" alt="Spielkarte" class="playcard" />
          </div>
          <div class="col-8">
            <p>{{ $t("tan.help.p1") }}</p>
            <p>{{ $t("tan.help.p2") }}</p>
            <p>{{ $t("tan.help.p3") }}</p>
          </div>
        </div>
      </div>
      <div class="popup" @click="popupState=''" v-if="popupState==='ERROR'">
        <button @click="popupState='';$refs.tan.focus()">X</button>
        <h2>{{ $t("tan.error.caption") }}</h2>
        <div class="row">
          <div class="col-4">
            <img :src="imageUrl()" alt="Clever" class="clever" />
          </div>
          <div class="col-8">
            <p>{{ $t("tan.error.invalid") }}</p>
            <p>{{ $t("tan.error.required") }}</p>
            <p>
              <a
                href="https://www.swiss-skills.ch/missionfuture/"
                target="_blank"
              >{{ $t("tan.help.help_faq") }}</a>
            </p>
          </div>
        </div>
      </div>
    </transition>
    <div class="row vertical-center">
      <div class="col-3">
        <img :src="imageUrl()" alt="Spielkarte" class="playcard" />
      </div>
      <div class="col-9">
        <div class="form-group">
          <h1>{{ $t("tan.caption") }}</h1>
          <p>
            {{ $t("tan.message") }}
            <br />
            {{ $t("tan.note") }}
            <br />
            <a @click="popupState='SHOW'">{{ $t("tan.help.codes") }}</a>
          </p>
          <input
            type="text"
            v-model="tan"
            maxlength="10"
            class="form-control"
            ref="tan"
            @keydown="validationState=''"
          />
          <br />
          <p v-html="$t('register.privacy')"></p>
        </div>
        <br />
        <div class="form-group right">
          <button class="btn btn-primary" @click="next"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import participant from "../modules/Participant"
import PSYAPI from "../modules/API"
import simulation from "../modules/Simulation"

export default {
  name: "Tan",
  data() {
    return {
      tan: simulation.mode === "staging" ? "7grf65" : null,
      validationState: "",
      popupState: "",
    }
  },
  validations: {
    tan: {
      required,
    },
  },
  methods: {
    next() {
      if (this.tan) {
        this.tan = this.tan.trim()
      }
      if (this.$v.$invalid) {
        this.validationState = "ERROR"
        this.popupState = "ERROR"
        this.$refs.tan.focus()

        setTimeout(() => {
          this.validationState = ""
        }, 30000)
      } else {
        PSYAPI.tan.validateTan(this.tan, participant.project.id, (verified) => {
          if (verified === true) {
            participant.tan = this.tan.trim()
            this.$router.push("/register")
          } else {
            this.validationState = "ERROR"
            this.popupState = "ERROR"
            this.$refs.tan.focus()
            window.scrollTo(0, 1)
          }
        })
      }
    },
    imageUrl() {
      let ctx = require.context("../assets/", false, /\.png/)
      return ctx("./code-" + this.$i18n.locale + ".png")
    },
  },
  mounted() {
    this.$refs.tan.focus()
    participant.tan = null
  },
}
</script>

<style scoped>
a {
  text-decoration: underline !important;
  font-style: italic !important;
  color: #006266 !important;
  font-size: 80%;
  cursor: grab;
}

h1 {
  background-color: #e5efef;
  padding: 10px;
  color: #006265;
  text-align: center;
}

h2 {
  font-family: MyriadSB, Arial, Helvetica, sans-serif;
  color: #006266;
}

#mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: black;
  opacity: 0.5;
  z-index: 1;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #e5efef;
  padding: 30px;
  border-radius: 30px;
  border: 1px solid #ccc;
  max-width: 800px;
  z-index: 2;
  font-size: 110%;
}

.popup h2 {
  margin-bottom: 25px;
}

.popup button {
  position: absolute;
  top: -16px;
  right: 0px;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  border: 1px solid gray;
  background-color: white;
  color: gray;
  font-weight: bold;
  outline: none;
}
.playcard {
  height: auto;
  width: 100%;
  max-width: 337px;
}

.clever {
  height: auto;
  width: 100%;
}
.err-enter,
.err-leave-to {
  visibility: hidden;
  opacity: 0;
}
.err-enter-active,
.err-leave-active {
  transition: all, 0.5s;
}
.btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: 770px) {
  .popup {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #e5efef;
    padding: 10px;
    border-radius: 30px;
    border: 1px solid #ccc;
    width: 95%;
    max-width: 800px;
    z-index: 2;
  }
}
@media screen and (max-width: 770px) and (orientation: landscape) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
</style>